import * as actionTypes from './actionTypes';

interface State {
  show: boolean;
  message: string;
  href: string;
}

const initialState: State = {
  show: false,
  message: '',
  href: ''
}

export const modalError = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.OPEN_MODAL_ERROR:
      return {
        show: action.show,
        message: action.message,
        href: action.href
      };
    case actionTypes.CLOSE_MODAL_ERROR:
      return {
        show: action.show,
        message: '',
        href:''
      };
    default:
      return state;
  }
}
